import { ComponentChildren, h } from 'preact'
import PanelHeader from './PanelHeader'
import PanelBody from './PanelBody'
import { IconType } from '../assets'

interface Props {
  children?: ComponentChildren,
  icon?: IconType,
  customClass? : string,
  titleClass? : string,
  bodyClass? : string,
  collapsible?: boolean,
  newStyle?: boolean,
  title?: ComponentChildren,
  customTogglePanel: () => void,
  isOpen?: boolean,
  heading?: string
}

const StatelessPanel = ({ children, customClass, collapsible = false, title, titleClass, bodyClass, customTogglePanel, newStyle = false, isOpen = false, heading }: Props) => {
  let hasChildren = (Array(children).toString() !== '')
  let baseClass = 'panel'
  if (newStyle) baseClass = `${baseClass}-new`
  return (
    <div>
      { heading && <h2 class='panel-new__heading'>{heading}</h2> }
      <div className={`${customClass || ''} ${!isOpen || !hasChildren ? `${baseClass}-collapsed` : ''}`}>
        <div class={baseClass}>
          { title
            ? <PanelHeader
              newStyle={newStyle}
              collapsible={collapsible}
              isOpen={isOpen}
              togglePanel={() => customTogglePanel()}
              title={title}
              customClass={titleClass}
            />
            : null }
          { hasChildren
            ? <PanelBody
              collapsible={collapsible}
              isOpen={isOpen}
              customClass={bodyClass}
            >
              {children}
            </PanelBody> : null }
        </div>
      </div>
    </div>
  )
}

export default StatelessPanel
